module.exports = __webpack_public_path__ + "static/media/SCBsend.bb8f1ccb.svg";